window.BK_SERVICE_MAP = {
  haircut: 'urn:blvd:Service:674849a4-f398-4173-89f3-d8ff907cb814',
  curly_cut: 'urn:blvd:Service:5c35844f-b486-4130-866b-f3a74ec8b757',
  haircut_pixie_short: 'urn:blvd:Service:66c4a2f5-f3e3-4185-86bd-e8bc78b12fa6',
  mens_haircut: 'urn:blvd:Service:44c640d1-c356-4025-aedc-835f84febf1e',
  bang_trim: 'urn:blvd:Service:442f91b4-905b-4488-9806-9deef114d07d',
  standalone_glaze: 'urn:blvd:Service:f43a9ec9-6a8d-42fd-a7fd-a86c355a8c5b',
  single_process: 'urn:blvd:Service:6209c796-7833-4a7e-9f75-05a594fc39c4',
  face_frame: 'urn:blvd:Service:c80b5963-f009-4008-8b82-2867270fdd7d',
  partial_highlight: 'urn:blvd:Service:7c0f17f7-6894-4dce-9689-820623575cab',
  full_highlight: 'urn:blvd:Service:cebcfcd9-c8b7-4479-a96d-f12d03dc7e67',
  blowdry_classic: 'urn:blvd:Service:8a712bbe-f544-4fcf-a8ff-d8be3fc79b1b',
  blowdry_signature: 'urn:blvd:Service:44b6f201-08ee-457e-9703-5bee8ff8db95',
  extension_consultation: 'urn:blvd:Service:7865a604-9cb1-47f0-8379-c1c878daa8c7',
  extension_maintenance: 'urn:blvd:Service:541dced2-72ae-4db1-b232-d8e25d8f85b2',
  extension_quick_fix: 'urn:blvd:Service:a79b7da0-725c-4af5-be41-7b6312b74bd3',
  treatment_smoothfiller: 'urn:blvd:Service:9f17aa8c-30a5-409b-b145-aad544be82aa',
  treatment_keratin: 'urn:blvd:Service:e16ccd87-380a-4758-87f7-2dee2eb1281d',
  treatment_keratin_hairline: 'urn:blvd:Service:2d2183a1-424c-4c44-a7c7-f9a6c34d8fd6',
  treatment_magic_sleek: 'urn:blvd:Service:e0ee57fd-84dd-4d98-a5fe-2bb99b17af5c'
};

window.BK_SERVICE_NAMES = {
  haircut: "Women's Haircut",
  curly_cut: 'hs.CurlyCut',
  haircut_pixie_short: "Women's Haircut (Pixie/Short)",
  mens_haircut: "Men's Haircut",
  bang_trim: 'Bang Trim',
  standalone_glaze: 'Glaze/Gloss',
  single_process: 'Single Process Touchup',
  face_frame: 'Face Frame',
  partial_highlight: 'Partial Highlight',
  full_highlight: 'Full Highlight',
  blowdry_classic: 'hs.Classic Blowdry',
  blowdry_signature: 'hs.Signature Blowdry',
  extension_consultation: 'Hair Extension Consultation',
  extension_maintenance: 'Hair Tied Weft Maintenance',
  extension_quick_fix: 'Hand Tied Quick Fix',
  treatment_smoothfiller: 'Wella SmoothFiller Treatment',
  treatment_keratin: 'Keratin Smoothing Treatment',
  treatment_keratin_hairline: 'Keratin Smoothing Treatment - Bangs/Hairline Only',
  treatment_magic_sleek: 'Magic-Sleek Smoothing Treatment'
};

window.BK_MODIFIER_MAP = {
  single_process: {
    glaze: {
      id: '9b2f3282-35bd-478f-b2c4-a7b2f703cd19',
      name: 'Glaze/Gloss'
    },
    extra_color: {
      id: '13ec4f0e-4998-4dd1-87ef-9e570fcd6497',
      name: 'Extra Color'
    },
    air_dry_transition: {
      id: '47b5acb9-d8f3-4df6-8314-0f96ed4ce45f',
      name: 'Air-Dry Transition Time'
    }
  },
  face_frame: {
    tipping: {
      id: 'be232134-f6f2-4c22-ad8a-1def7162e5e2',
      name: 'Tipping'
    },
    lowlights: {
      id: '57f71ba7-db0f-4845-8ea8-a6eca05e7d03',
      name: 'Lowlights'
    },
    pretone: {
      id: 'd701de74-fa06-4679-ad8a-a1d234087a12',
      name: 'Pretone'
    },
    root_shadow: {
      id: '9015d91b-b2b6-44a6-aeee-dccfc9da97aa',
      name: 'Root Shadow'
    }
  },
  partial_highlight: {
    tipping: {
      id: 'b57d6fe2-11d3-4c57-b950-997bc60af1e0',
      name: 'Tipping'
    },
    pretone: {
      id: 'ca1f6c95-141c-4eaf-824c-9c75c291ee67',
      name: 'Pretone'
    },
    lowlights: {
      id: 'a05e09fb-f7e3-41ea-a6ee-2ac6e460e54a',
      name: 'Lowlights'
    },
    root_shadow: {
      id: '09f0fd7b-7bae-4de5-a016-0f62c8962998',
      name: 'Root Shadow'
    },
    long_thick: {
      id: 'be353788-1d56-4001-879c-0a03def9794e',
      name: 'My hair is extra long or thick'
    }
  },
  full_highlight: {
    tipping: {
      id: 'd2ae2a54-08b8-42de-b202-52d9b8b6f3a8',
      name: 'Tipping'
    },
    lowlights: {
      id: '239a9acc-025f-4c1c-ba19-39d1874bb4b5',
      name: 'Lowlights'
    },
    pretone: {
      id: '1c50379d-ffbb-4ab9-a1f7-5d7cc8c5c3da',
      name: 'Pretone'
    },
    root_shadow: {
      id: '78a202fb-3407-4e1b-9b4c-f08f684db902',
      name: 'Root Shadow'
    },
    long_thick: {
      id: '10477f39-f395-4424-bbc7-c78302ffed7d',
      name: 'My hair is extra long or thick'
    }
  },
  haircut: {
    long_thick: {
      id: 'e8defd3d-16b9-4295-8c00-bbb37c23b70b',
      name: 'My hair is long or thick'
    },
    big_change: {
      id: '43956931-322c-4f2a-9f69-0bcdf5539b41',
      name: 'I am looking for a big change'
    }
  },
  blowdry_classic: {
    standard: {
      id: 'f348488e-9443-4f87-a7d8-68a52d5744e1',
      name: 'Standard Length and Texture'
    },
    extensions: {
      id: '7d083367-a306-43bc-8901-a18b760926ef',
      name: 'Blowdry with Extensions'
    },
    long_thick: {
      id: '449e73ff-4b0b-4bbe-83e5-ca024ac0be09',
      name: 'Blowdry for Long or Thick Hair'
    }
  },
  blowdry_signature: {
    standard: {
      id: '1f6aa16c-e66b-487f-b703-7e0d33f33d8d',
      name: 'Standard Length and Texture'
    },
    extensions: {
      id: 'cd77c423-4467-4d08-ba5d-0e0cab36db34',
      name: 'Blowdry with Extensions'
    },
    long_thick: {
      id: 'd44fc9ca-2951-4272-8bce-eee5c78f057a',
      name: 'Blowdry for Long or Thick Hair'
    }
  },
  extension_maintenance: {
    one_track: {
      id: '5be0a490-fc53-4882-97fe-affb2b84ba7c',
      name: '1 Track'
    },
    two_tracks: {
      id: '9e3b9792-0f9e-44c2-81b0-efda6c59ca5a',
      name: '2 Tracks'
    },
    three_tracks: {
      id: 'febe25f5-5952-490d-ae23-8a9169459401',
      name: '3 Tracks'
    }
  }
};

window.BK_PHOTO_OPTION_NAMES = {
  '43956931-322c-4f2a-9f69-0bcdf5539b41': 'I am looking for a big change',
  'e8defd3d-16b9-4295-8c00-bbb37c23b70b': 'My hair is long or thick',
  '9b2f3282-35bd-478f-b2c4-a7b2f703cd19': 'Glaze/Gloss',
  '13ec4f0e-4998-4dd1-87ef-9e570fcd6497': 'Extra Color',
  '47b5acb9-d8f3-4df6-8314-0f96ed4ce45f': 'Air-Dry Transition Time',
  'be232134-f6f2-4c22-ad8a-1def7162e5e2': 'Tipping',
  '57f71ba7-db0f-4845-8ea8-a6eca05e7d03': 'Lowlights',
  'd701de74-fa06-4679-ad8a-a1d234087a12': 'Pretone',
  '9015d91b-b2b6-44a6-aeee-dccfc9da97aa': 'Root Shadow',
  'b57d6fe2-11d3-4c57-b950-997bc60af1e0': 'Tipping',
  'ca1f6c95-141c-4eaf-824c-9c75c291ee67': 'Pretone',
  'a05e09fb-f7e3-41ea-a6ee-2ac6e460e54a': 'Lowlights',
  '09f0fd7b-7bae-4de5-a016-0f62c8962998': 'Root Shadow',
  'be353788-1d56-4001-879c-0a03def9794e': 'My hair is extra long or thick',
  'd2ae2a54-08b8-42de-b202-52d9b8b6f3a8': 'Tipping',
  '239a9acc-025f-4c1c-ba19-39d1874bb4b5': 'Lowlights',
  '1c50379d-ffbb-4ab9-a1f7-5d7cc8c5c3da': 'Pretone',
  '78a202fb-3407-4e1b-9b4c-f08f684db902': 'Root Shadow',
  '10477f39-f395-4424-bbc7-c78302ffed7d': 'My hair is extra long or thick',
  'f348488e-9443-4f87-a7d8-68a52d5744e1': 'Standard Length and Texture',
  '449e73ff-4b0b-4bbe-83e5-ca024ac0be09': 'Blowdry for Long or Thick Hair',
  '7d083367-a306-43bc-8901-a18b760926ef': 'Blowdry with Extensions',
  '1f6aa16c-e66b-487f-b703-7e0d33f33d8d': 'Standard Length and Texture',
  'd44fc9ca-2951-4272-8bce-eee5c78f057a': 'Blowdry for Long or Thick Hair',
  'cd77c423-4467-4d08-ba5d-0e0cab36db34': 'Blowdry with Extensions',
  '5be0a490-fc53-4882-97fe-affb2b84ba7c': '1 Track',
  '9e3b9792-0f9e-44c2-81b0-efda6c59ca5a': '2 Tracks',
  'febe25f5-5952-490d-ae23-8a9169459401': '3 Tracks'
};

window.BK_PHOTO_HAIRCUT_CONFIRM_QUESTION_ID = 'client_confirm_haircut';
window.BK_PHOTO_HAIRCUT_BIG_CHANGE_QUESTION_ID = 'client_confirm_haircut_big_change';
window.BK_PHOTO_GRAY_COVERAGE_QUESTION_ID = 'gray_coverage_intent';
window.BK_PHOTO_GRAY_STRATEGY_QUESTION_ID = 'gray_strategy_followup';
window.BK_PHOTO_INSPO_FOCUS_AREAS_QUESTION_ID = 'inspo_focus_areas';
window.BK_PHOTO_INSPO_FOCUS_AREAS_LEGACY_QUESTION_ID = 'multi_inspo_focus_areas';

window.BK_SERVICE_ID_ALIASES = {
  'urn:blvd:Service:6209c796-7833-4f2a-9f75-05a594fc39c4': 'urn:blvd:Service:6209c796-7833-4a7e-9f75-05a594fc39c4',
  'urn:blvd:Service:6209c796-7833-4f7e-9f75-05a594fc39c4': 'urn:blvd:Service:6209c796-7833-4a7e-9f75-05a594fc39c4',
  'urn:blvd:Service:6209c796-7833-4e7e-9f75-05a594fc39c4': 'urn:blvd:Service:6209c796-7833-4a7e-9f75-05a594fc39c4'
};

window.BK_THINKING_LINES_BY_MODE = {
  default: ['pulling together the details of your look...'],
  refine: ['pulling together the details of your consult...']
};

window.BK_GRAY_COVERAGE_OPTIONS = [
  {
    id: 'gray_coverage',
    label: 'I want gray truly covered',
    description: 'Gray showing at the root bothers me, and I would rather cover it clearly even if that means a firmer grow-out line and more frequent maintenance.'
  },
  {
    id: 'gray_unsure',
    label: 'I need help choosing the right gray path',
    description: 'Walk me through the difference between stronger coverage, softer blending, and the lower-coverage dimensional path.'
  },
  {
    id: 'no_gray',
    label: 'Gray is not part of this visit',
    description: 'I am focused on tone, richness, brightness, or dimension instead.'
  }
];

window.BK_GRAY_STRATEGY_OPTIONS = [
  {
    id: 'full_coverage',
    label: 'I want every gray covered',
    description: 'Best when you want grays truly hidden. This is usually the strongest root coverage path and typically means maintenance about every 4-6 weeks.'
  },
  {
    id: 'soft_blending',
    label: 'I want gray softened and blended',
    description: 'Best for more sporadic gray when you want less contrast at grow-out instead of hard coverage. Usually lands closer to every 6-8 weeks.'
  },
  {
    id: 'dimensional_blend',
    label: 'I would rather let gray live inside dimension',
    description: 'This is the lowest-coverage path and usually stretches maintenance to about 8-12 weeks, but it is a weaker fit if you want more depth on top and less highlighting there.'
  }
];

window.BK_INSPO_FOCUS_OPTIONS = [
  {
    id: 'haircut',
    label: 'The haircut shape and length',
    description: 'Things like the bob length, silhouette, fringe, or overall shape.'
  },
  {
    id: 'brightness',
    label: 'The brightness and highlighted dimension',
    description: 'Things like how blonde it is, where the lightness sits, and how much highlight you see.'
  },
  {
    id: 'tone',
    label: 'The tone',
    description: 'Things like cooler, warmer, softer, beige, ash, creamy, or richer tonal direction.'
  },
  {
    id: 'root_softness',
    label: 'The softer root or blend',
    description: 'Things like a diffused root, root shadow, or less contrast right at the scalp.'
  },
  {
    id: 'overall_depth',
    label: 'The depth or contrast',
    description: 'Things like how deep the top feels, how much contrast there is, or whether it reads richer versus brighter.'
  },
  {
    id: 'overall_vibe',
    label: 'The overall vibe or polish',
    description: 'Things like softness, lived-in feel, polish, richness, or the whole mood of the result.'
  }
];

window.BK_INSPO_FOCUS_ALIAS_MAP = {
  haircut: ['cut', 'haircut_shape', 'haircut_shape_and_layers', 'haircut_layers', 'layers'],
  brightness: ['color', 'red_ends', 'dimension_pattern', 'dimension_highlights', 'dimension_and_highlights', 'highlight_level_and_tone'],
  tone: ['base_color', 'base_level_and_tone', 'highlight_level_and_tone', 'red_ends'],
  root_softness: ['base_color', 'root_blend', 'root_shadow'],
  overall_depth: ['base_color', 'depth', 'contrast', 'base_depth'],
  overall_vibe: ['finish', 'styling', 'finish_style', 'overall_finish', 'styling_finish']
};

window.BK_PHOTO_CONSULT_LINES_BY_ID = {
  gray_coverage_intent: [
    'Mapping the right gray coverage path',
    'An expert colorist would separate full coverage from softer blending here',
    'This answer shapes maintenance, base depth, and how strong the coverage needs to be'
  ],
  gray_strategy_followup: [
    'Narrowing the gray coverage strategy',
    'Thinking through coverage strength versus softness at grow-out',
    'Balancing richness, maintenance, and how solid the root result should feel'
  ],
  client_confirm_haircut: [
    'Separating haircut goals from color goals',
    'Checking whether this visit is color-only or color plus shape work',
    'Keeping the booking focused on what actually needs chair time'
  ],
  client_confirm_haircut_big_change: [
    'Gauging the haircut scope',
    'Figuring out whether this is a trim or a bigger shape change',
    'That changes timing and booking order more than most guests realize'
  ],
  inspo_focus_areas: [
    'Translating the inspo into what actually matters to you',
    'Separating the visible differences between your current hair and the target look',
    'This keeps the plan focused on your real goal instead of assuming you want every part of the photo'
  ]
};

window.BK_PHOTO_SUPPORT_TEXT_BY_ID = {
  gray_coverage_intent: 'Gray coverage changes the color strategy a lot, so this helps us separate full root coverage from softer blending and lower-maintenance options.',
  gray_strategy_followup: 'These are the three most common gray paths a colorist would walk through with you: strongest coverage, softer blending, or the easiest grow-out.',
  client_confirm_haircut: 'We ask this separately so the booking reflects what you actually want from this visit, instead of assuming the photo inspiration means haircut plus color.',
  client_confirm_haircut_big_change: 'A big haircut change books differently from a trim or shape cleanup, so we separate those two paths here.',
  inspo_focus_areas: 'These are the main differences we noticed between your current hair and the inspiration. Check anything that actually belongs in your goal so the plan reflects your priorities, not just the whole photo.'
};

window.BK_BOOKING_QUESTION_SCREENS = [
  'blowdry-style',
  'haircut-type',
  'extensions-type',
  'extension-maintenance-tracks',
  'extension-blowdry',
  'treatment-type',
  'treatment-haircut',
  'treatment-blowdry',
  'blowdry-hair-type',
  'color-goal',
  'color-placement',
  'color-haircut',
  'color-blowdry',
  'modifier-glaze',
  'modifier-haircut-thick',
  'modifier-haircut-change'
];

window.BK_BOOKING_PROGRESS_BY_SCREEN = {
  entry: 0,
  'photo-analyze': 8,
  'photo-followup': 18,
  'blowdry-style': 18,
  'haircut-type': 18,
  'extensions-type': 18,
  'extension-maintenance-tracks': 28,
  'extension-blowdry': 36,
  'treatment-type': 18,
  'treatment-haircut': 28,
  'treatment-blowdry': 36,
  'blowdry-hair-type': 30,
  'color-goal': 18,
  'color-placement': 28,
  'color-haircut': 36,
  'color-blowdry': 44,
  'modifier-glaze': 36,
  'modifier-haircut-thick': 44,
  'modifier-haircut-change': 44,
  'stylist-per-service': 58,
  time: 74,
  guest: 86,
  review: 94,
  done: 100
};

window.BK_INITIAL_STATE = {
  screen: 'entry',
  lastBookingScreen: 'entry',
  rangeKey: 'week_0',
  stylistStepIndex: 0,
  answers: {
    entryChoice: '',
    manualServiceKey: '',
    extensionMaintenanceTracks: '',
    extensionNeedsBlowdry: null,
    blowdryStyle: '',
    blowdryHairType: '',
    colorGoal: '',
    colorDimensionPlacement: '',
    colorNeedsHaircut: null,
    colorNeedsBlowdry: null,
    treatmentNeedsHaircut: null,
    treatmentNeedsBlowdry: null,
    singleProcessGlaze: null,
    haircutLongOrThick: null,
    haircutBigChange: null
  },
  photoGoal: '',
  photoApplied: false,
  photoAnalysis: null,
  photoSuggestedServices: [],
  photoFollowUpAnswers: {},
  photoCommittedQuestionIds: {},
  serviceStack: [],
  staffDirectory: [],
  staffDirectoryPage: {
    loading: false,
    error: '',
    supported: false,
    staff: [],
    debug: null,
    expandedId: ''
  },
  staffOptionsByService: {},
  slotId: '',
  slotLabel: '',
  slotStartAt: '',
  slotEstimate: null,
  slotEstimateLoading: false,
  availabilityLoading: false,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  gratuityChoice: 'none',
  gratuityCustom: '',
  cardName: '',
  cardNumber: '',
  cardExpMonth: '',
  cardExpYear: '',
  cardCvv: '',
  cardPostal: '',
  selectedSavedCardId: '',
  confirmation: null,
  clientDashboard: {
    profile: null,
    appointments: []
  },
  clientAccount: {
    loading: false,
    waitlistLoading: false,
    waitlistMode: 'first_available',
    waitlistPreferredDate: '',
    authMethod: 'phone',
    identifier: '',
    verificationCode: '',
    requestId: '',
    challengeToken: '',
    clientToken: '',
    dashboardSection: 'appointments',
    dashboardTab: 'upcoming',
    bootstrap: null,
    authStart: null,
    authVerify: null,
    dashboardData: null,
    appointmentAction: {
      appointmentId: '',
      mode: '',
      loading: false,
      selectedDate: '',
      dates: [],
      times: []
    }
  }
};
